var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowed)?_c('a-button',{staticClass:"BackButton inline-flex items-center justify-center w-12 p-0",on:{"click":_vm.navigateBack}},[_c('a-icon',{attrs:{"type":"left"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }